import React from 'react';
import useGroupResizeBehaviour, { ResizeProps } from './useGroupResizeBehaviour';

/**
 * Decorator that handles group resizing/repositioning for the current element.
 * To be used along with the `groupResizeStateDecorator` which provides resizing state and actions, and the`ResizeHandle` which provides the drag handle and handles the event listeners.
 * Any custom update functionality can be added as a decorator between this one and the `groupResizeStateDecorator`.
 */
export default <T extends ResizeProps>(getIsRepositionOnly?: (props: ResizeProps) => boolean) =>
    (DecoratedComponent: React.ComponentType<T>): React.FC<T> => {
        return (props: T) => {
            useGroupResizeBehaviour(props, getIsRepositionOnly);
            return <DecoratedComponent {...props} />;
        };
    };
